module.exports = __webpack_public_path__ + "img/violet_104.ff5052c5.png";